import { all, takeLatest, put, call, select, delay, take, race, fork } from "redux-saga/effects";
import userGroupsSearchSlice, { loadUserGroups } from "./slice";
import { AxiosResponse } from "axios";
import { SimplyTestApi } from "../../../api/simplytest";
import { UserGroupsResponse } from "../../../api/types";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { selectConfig } from "../../../shared/redux/slice";
import { IConfiguration } from "../../../shared/types";

export abstract class UserGroupsSearchSagas {
    public static* run() {
        try {
            yield all([
                takeLatest(loadUserGroups, UserGroupsSearchSagas.loadUserGroups),
            ]);
        }
        catch(e: any){
            console.log(`[UserGroupsSearchSagas:run] the following exception has occurred`, e);    
        }
    }

    public static *loadUserGroups(action: ReturnType<typeof loadUserGroups>) {
        try {
            yield put(userGroupsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const userGroupsResponse: AxiosResponse<UserGroupsResponse> = yield call(
                {
                    context: client,
                    fn: client.getUserGroups,
                },
            );

            if(userGroupsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(userGroupsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            const { data: userGroups } = userGroupsResponse;
            yield put(userGroupsSearchSlice.actions.setUserGroups(userGroups));
            yield put(userGroupsSearchSlice.actions.setState('READY'));
        }
        catch(e: any){
            console.log(`[UserGroupsSearchSagas:run] the following exception has occurred`, e);    
        }
    }
}